import React from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Grid,
  Box,
} from "@mui/material";

const STEP_TITLE = "Lokalita";

/**
 * Step 3: Lokalita – location/contact fields.
 * Required: Názov lokality / prevádzky, PSČ, Obec, Krstné meno, Priezvisko, Telefón.
 * Optional: IČO, DIČ, IČ DPH, Ulica.
 */
const Step3Lokalita = ({ values, errors, onChange }) => {
  const handleChange = (field) => (e) => {
    onChange(field, e.target.value);
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {STEP_TITLE}
        </Typography>
        <Box sx={{ pt: 2 }}>
          <Grid container spacing={3}>
            {/* Row 0: Názov lokality / prevádzky (required) */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Názov lokality / prevádzky *"
                value={values.locationName ?? ""}
                onChange={handleChange("locationName")}
                error={!!errors.locationName}
                helperText={errors.locationName}
                variant="outlined"
              />
            </Grid>

            {/* Row 1: IČO, DIČ, IČ DPH (optional) */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="IČO"
                value={values.ico ?? ""}
                onChange={handleChange("ico")}
                error={!!errors.ico}
                helperText={errors.ico}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="DIČ"
                value={values.dic ?? ""}
                onChange={handleChange("dic")}
                error={!!errors.dic}
                helperText={errors.dic}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="IČ DPH"
                value={values.icDph ?? ""}
                onChange={handleChange("icDph")}
                error={!!errors.icDph}
                helperText={errors.icDph}
                variant="outlined"
              />
            </Grid>

            {/* Row 2: Ulica (optional) */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Ulica"
                value={values.street ?? ""}
                onChange={handleChange("street")}
                error={!!errors.street}
                helperText={errors.street}
                variant="outlined"
              />
            </Grid>

            {/* Row 3: PSČ (required), Obec (required) */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="PSČ *"
                value={values.zip ?? ""}
                onChange={handleChange("zip")}
                error={!!errors.zip}
                helperText={errors.zip}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Obec *"
                value={values.city ?? ""}
                onChange={handleChange("city")}
                error={!!errors.city}
                helperText={errors.city}
                variant="outlined"
              />
            </Grid>

            {/* Row 4: Krstné meno (required), Priezvisko (required), Telefón (required) */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Krstné meno *"
                value={values.firstName ?? ""}
                onChange={handleChange("firstName")}
                error={!!errors.firstName}
                helperText={errors.firstName}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Priezvisko *"
                value={values.lastName ?? ""}
                onChange={handleChange("lastName")}
                error={!!errors.lastName}
                helperText={errors.lastName}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Telefón *"
                value={values.phone ?? ""}
                onChange={handleChange("phone")}
                error={!!errors.phone}
                helperText={errors.phone}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Step3Lokalita;
